import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { selectCommunicationData } from "../store";
import { captchaChallengeAct, executePollingAct, loadCommunicationAct } from "../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import useIsLinearPreRun from "../utils/hooks/useIsLinearPreRun";
import SplashScreenPageLinear from "./linear/SplashScreenPageLinear";
import SplashScreenPage from "./SplashScreenPage";

export default function AppWrapper(props?: { checkStorage?: boolean }) {
    const [pollingInterval, setPollingInterval] = useState(null);
    let navigate = useNavigate();
    const dispatch = useAppDispatch();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)

    const { communication } = communicationData
    const isLinear = useIsLinearPreRun();

    const communicationLoaded = !!communication?.token
    const disappearClass = communicationLoaded ? 'make-disappear' : ''

    useEffect(() => {
        if (communicationLoaded && isLinear === false) {
            // call backend for polling
            const _pollingInterval: any = setInterval(() => {
                dispatch(executePollingAct({
                    token,
                    navigate
                }))
            }, window.REACT_APP_POLLING_INTERVAL_IN_MS);
            setPollingInterval(_pollingInterval);
        }
        return () => {
            pollingInterval && clearInterval(pollingInterval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [communicationLoaded])

    useEffect(() => {
        //console.log(route)
        dispatch(loadCommunicationAct({
            token,
            navigate
        }));
        dispatch(captchaChallengeAct(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div id="realtime-app-wrapper">
                {communicationLoaded && <Outlet />}
                {!communicationLoaded && isLinear === true && <SplashScreenPageLinear className={disappearClass} />}
                {!communicationLoaded && isLinear === false && <SplashScreenPage className={disappearClass} />}
            </div>
        </>
    );
}
